<template lang="pug">
.v-faq.faq(v-if="data" :id="data?.id")
	.faq__inner
		.faq__title(v-if="data.title") {{data.title}}
		v-acc.faq__acc(v-if="data.items" :items="data.items")
</template>
<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>